export default __webpack_public_path__ + "static/media/FilterSVG.9d7459af.svg";